import { testId } from '../../utils';
import clsx from 'clsx';
import {
  IPaginationProps,
  Pagination as Paginate,
} from 'react-headless-pagination';

interface PaginationProps extends IPaginationProps {
  'data-testid': string;
}

export const Pagination = ({
  currentPage,
  edgePageCount,
  middlePagesSiblingCount,
  setCurrentPage,
  totalPages,
  'data-testid': dataTestId,
}: PaginationProps) => (
  <Paginate
    totalPages={totalPages}
    edgePageCount={edgePageCount}
    middlePagesSiblingCount={middlePagesSiblingCount}
    currentPage={currentPage}
    setCurrentPage={setCurrentPage}
    className="flex"
    truncableText="..."
    truncableClassName=""
    {...testId(dataTestId)}
  >
    <Paginate.PrevButton
      {...testId(dataTestId, 'prev')}
      className={clsx('text-gray-darkest', {
        'cursor-pointer': currentPage !== 0,
        'opacity-50': currentPage === 0,
      })}
    >
      <span className="material-symbols-outlined">arrow_back_ios</span>
    </Paginate.PrevButton>

    <nav className="flex justify-center flex-grow">
      <ul className="flex items-center">
        <Paginate.PageButton
          {...testId(dataTestId, 'page-button')}
          activeClassName="bg-blue-active text-white"
          inactiveClassName="text-blue-active"
          className="no-underline p-6"
        />
      </ul>
    </nav>

    <Paginate.NextButton
      {...testId(dataTestId, 'next')}
      className={clsx('text-gray-darkest', {
        'cursor-pointer': currentPage !== totalPages - 1,
        'opacity-50': currentPage === totalPages - 1,
      })}
    >
      <span className="material-symbols-outlined">arrow_forward_ios</span>
    </Paginate.NextButton>
  </Paginate>
);
